










import { method } from "lodash";
import Vue from "vue";
export default Vue.extend({
  props: {
    color: { type: String, default: "" },
    textTooltip: { type: String, default: "" },
    icon: { type: String, default: "" },
    eventName: { type: String, default: "" },
  },
  methods: {
    event() {
      this.$emit(this.eventName);
    },
  },
});
